import { Button } from "./button"
import { cn } from "@/lib/utils"

interface ButtonLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: "default" | "outline" | "secondary"
  size?: "default" | "sm" | "lg"
}

export function ButtonLink({
  className,
  variant = "default",
  size = "default",
  ...props
}: ButtonLinkProps) {
  return (
    <a
      className={cn(
        "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
        {
          "bg-brand-primary-60 text-brand-shape-50 hover:bg-brand-primary-50": variant === "default",
          "border border-brand-shape-300 hover:bg-brand-shape-100": variant === "outline",
          "bg-brand-shape-200 text-brand-primary-60 hover:bg-brand-shape-300": variant === "secondary",
        },
        {
          "h-10 px-4 py-2": size === "default",
          "h-9 px-3": size === "sm",
          "h-11 px-8": size === "lg",
        },
        className
      )}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    />
  )
}